(function () {
    'use strict';

    var serviceId = 'parcelClientService';

    angular.module('app.common')
        .factory(serviceId, ['$http', '$q', 'appSettingsSvc', 'guardSvc', '$window', '$ocLazyLoad', parcelClientService]);

    function parcelClientService($http, $q, appSettingsSvc, guardSvc, $window, $ocLazyLoad) {

        var obj = {
            getCities: getCities,
            getCounties: getCounties,
            getNeighborhoods: getNeighborhoods,
            getParcelInfoById: getParcelInfoById,
            getParcelByValues: getParcelByValues,
            getParcelFromLocation: getParcelFromLocation,
            getParcelInfoByPropertyId: getParcelInfoByPropertyId,
            fixSelections: fixSelections,
            getBB: getBB,
            asignParcelProperties: asignParcelProperties
        };


        function fixSelections(data, officeRights, hasAdvance) {
            if ($window.parcelRecord && $window.parcelRecord.data.nitelik) {
                var nitelik = $window.parcelRecord.data.nitelik.toLowerCase();
                if (officeRights && (nitelik.indexOf('tarla') > -1 || nitelik.indexOf('çayır') > -1 || nitelik.indexOf('arazi') > -1)) {
                    data.PropertyCategory = 3;
                    data.PropertyType = 2;
                }
                else if (officeRights && nitelik.indexOf('arsa') > -1) {
                    data.PropertyCategory = 3;
                    data.PropertyType = 1;
                }
                else {
                    data.PropertyCategory = hasAdvance ? 2 : 1;
                }
            }
        }


        function getCities(cache) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/illiste', {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });
            return deferred.promise;
        }


        //$http cache'i 404'leri saklamadığı için blok isteğini promise bazında memoize ediyoruz (ES-4304)
        var blockRequests = {};

        function getBlock(cache, mahalle, ada, parsel) {
            if ($window.parcelRecord.data && ($window.parcelRecord.data.nitelik.toLowerCase().indexOf('arazi') > -1 || $window.parcelRecord.data.nitelik.toLowerCase().indexOf('tarla') > -1 || $window.parcelRecord.data.nitelik.toLowerCase().indexOf('çayır') > -1))
                return $q.resolve({
                    result: "success",
                    data: null
                });
            if (cache)
                return $q.resolve({
                    result: "success",
                    data: cache
                });
            var key = mahalle + '/' + ada + '/' + parsel;
            if (blockRequests[key])
                return blockRequests[key];
            blockRequests[key] = $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/blok/' + key, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    return {
                        result: "success",
                        data: response.data || null
                    };
                }).catch(
                    function (err) {
                        //Sadece 404 kalıcı; geçici hatalarda bir sonraki akış yeniden denesin
                        if (err.status !== 404)
                            delete blockRequests[key];
                        return {
                            result: "success",
                            data: null
                        };
                    });
            return blockRequests[key];
        }
        function getBB(cache, mahalle, ada, parsel, Block) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/bagimsizbolum/' + mahalle + '/' + ada + '/' + parsel + '/' + Block, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.resolve({
                            result: "success",
                            data: null
                        });
                }).catch(
                    function () {
                        deferred.resolve({
                            result: "success",
                            data: null
                        });
                    });
            return deferred.promise;
        }

        function getCounties(ilid, cache, pass) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/ilceliste/' + ilid, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });

            return deferred.promise;
        }

        function getNeighborhoods(ilceid, cache, pass) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            //Proxy hizmeti normale dönene kadar cacheliyoruz
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/mahalleliste/' + ilceid, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });
            return deferred.promise;
        }

        function getParcelByValues(mahalle, ada, parsel) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + mahalle + '/' + ada + '/' + parsel, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (result) {
                    if (result.data) {
                        asignParcelProperties(result).then(function () {
                            getBlock(null, mahalle, ada, parsel).then(function (resb) {
                                if (resb.data)
                                    $window.parcelRecord.blocks = resb.data.features;
                                deferred.resolve({
                                    result: "success",
                                    data: $window.parcelRecord
                                });
                            });
                        });
                    } else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });


            return deferred.promise;
        }

        function asignParcelProperties(asign) {
            var deferred = $q.defer();
            $ocLazyLoad.load('/assets/js/polylabel.js?v=' + window.appVersion).then(function () {
                var geometry = asign.data ? asign.data.geometry : asign.geometry;
                var properties = asign.data ? asign.data.properties : asign.properties.parcelDetails.properties;
                var geoData = asign.data ? asign.data : asign.properties.parcelDetails;

                $window.parcelRecord = {
                    ilId: properties.ilId,
                    ilceId: properties.ilceId,
                    mahalleId: properties.mahalleId,
                    ada: properties.adaNo,
                    parselId: properties.parselId,
                    geo: geoData,
                    data: properties,
                    center: null
                };
                var geoms, center;
                if (!properties.gittigiParselSebep) {
                    geoms = geometry.coordinates;
                    if (geometry.type === "MultiPolygon") geoms = geometry.coordinates[0];
                    else if (geometry.type === "Polygon" && geoms[0][0].length > 2) geoms = geometry.coordinates[0][1];
                    else if (geometry.type === "GeometryCollection")
                        geoms = geometry.geometries[0].coordinates;
                    try {
                        center = polylabel(geoms, 1.0);
                        $window.parcelRecord.center = center;
                        $window.selectedLocation = $window.parcelRecord.center[0] + " " + $window.parcelRecord.center[1];
                        $window.gatheredLocation = $window.selectedLocation;
                    }
                    catch (err) {
                        console.error(err);
                    }
                } else {
                    alert(
                        "Bu parsel değiştirilmiştir. Açıklama: " +
                        properties.gittigiParselSebep +
                        ". Yeni parsele yönlendiriliyorsunuz..."
                    );
                    var gittigi = JSON.parse(properties.gittigiParselListe);
                    if (gittigi.features.length) {
                        $window.parcelRecord = {
                            ilId: gittigi.features[0].properties.ilId,
                            ilceId: gittigi.features[0].properties.ilceId,
                            mahalleId: gittigi.features[0].properties.mahalleId,
                            ada: gittigi.features[0].properties.adaNo,
                            parselId: gittigi.features[0].properties.parselId,
                            geo: gittigi.features[0],
                            data: gittigi.features[0].properties,
                            center: null,
                            bb: (gittigi.features[0].properties.bagimsizBolum ? JSON.parse(gittigi.features[0].properties.bagimsizBolum) : null)
                        };
                    }
                    else if (gittigi.properties) {
                        $window.parcelRecord = {
                            ilId: gittigi.properties.ilId,
                            ilceId: gittigi.properties.ilceId,
                            mahalleId: gittigi.properties.mahalleId,
                            ada: gittigi.properties.adaNo,
                            parselId: gittigi.properties.parselId,
                            geo: gittigi,
                            data: gittigi.properties,
                            center: null,
                            bb: (gittigi.properties.bagimsizBolum ? JSON.parse(gittigi.properties.bagimsizBolum) : null)
                        };
                    }
                    geoms = gittigi.features[0].geometry.coordinates;
                    if (gittigi.features[0].geometry.type === "MultiPolygon") geoms = gittigi.features[0].geometry.coordinates[0];
                    else if (gittigi.features[0].geometry.type === "Polygon" && geoms[0][0].length > 2) geoms = gittigi.features[0].geometry.coordinates[0][1];
                    else if (geometry && geometry.type === "GeometryCollection")
                        geoms = geometry.geometries[0].coordinates;
                    try {
                        center = polylabel(geoms, 1.0);
                        $window.parcelRecord.center = center;
                        $window.selectedLocation = $window.parcelRecord.center[0] + " " + $window.parcelRecord.center[1];
                        $window.gatheredLocation = $window.selectedLocation;
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                deferred.resolve();
            });
            return deferred.promise;
        }

        function getParcelFromLocation(lat, lng, pass) {
            var deferred = $q.defer();
            if ($window.parcelRecord && !$window.parcelRecord.bb || !$window.parcelRecord) {
                $window.parcelRecord = null;
                guardSvc.hasPackage().then(function (res) {
                    if (res || pass) {
                        $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + lat + '/' + lng, {
                            cache: true,
                            skipAuthorization: true
                        }).then(
                            function (result) {
                                if (result.data) {
                                    asignParcelProperties(result).then(function () {
                                        getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                            if (resb.data)
                                                $window.parcelRecord.blocks = resb.data.features;
                                            deferred.resolve({
                                                result: "success",
                                                data: $window.parcelRecord
                                            });
                                        });
                                    });
                                }
                                else
                                    deferred.reject({
                                        result: "failure",
                                        error: "Bir sorun ile karşılaştık."
                                    });
                            }).catch(
                                function () {
                                    $window.parcelRecord = null;
                                    deferred.reject({
                                        result: "failure",
                                        error: "Bir sorun ile karşılaştık."
                                    });
                                });
                    }
                    else {
                        $window.parcelRecord = null;
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    }
                });
            }
            else {
                $window.parcelRecord = null;
                deferred.reject({
                    result: "failure",
                    error: "Bir sorun ile karşılaştık."
                });
            }

            return deferred.promise;
        }

        function getParcelInfoById(parselid) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + parselid,
                //return $http.get('/api/endeks/ParselIdParselBilgisiGetir?id=' + parselid,
                {
                    cache: true,
                    skipAuthorization: true
                }).then(
                    function (result) {
                        if (result.data) {
                            asignParcelProperties(result).then(function () {
                                getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                    if (resb.data)
                                        $window.parcelRecord.blocks = resb.data.features;
                                    deferred.resolve({
                                        result: "success",
                                        data: $window.parcelRecord
                                    });
                                });
                            });
                        } else
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                    }).catch(
                        function () {
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                        });
            return deferred.promise;
        }

        function getParcelInfoByPropertyId(zeminid) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=zemin//' + zeminid,
                {
                    cache: true,
                    skipAuthorization: true
                }).then(
                    function (result) {
                        if (result.data) {
                            asignParcelProperties(result).then(function () {
                                getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                    if (resb.data)
                                        $window.parcelRecord.blocks = resb.data.features;
                                    deferred.resolve({
                                        result: "success",
                                        data: $window.parcelRecord
                                    });
                                });
                            });
                        } else
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                    }).catch(
                        function () {
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                        });
            return deferred.promise;
        }


        return obj;
    }


})();
